var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilePause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2088_35381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00977 0H1.61765C0.725767 0 0 0.729066 0 1.625V24.375C0 25.271 0.725767 26 1.61765 26H7.00982C7.9017 26 8.62747 25.271 8.62747 24.375V1.625C8.62742 0.729066 7.90165 0 7.00977 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9509 0H14.5588C13.6669 0 12.9412 0.729066 12.9412 1.625V24.375C12.9412 25.271 13.6669 26 14.5588 26H19.951C20.8429 26 21.5687 25.271 21.5687 24.375V1.625C21.5685 0.729066 20.8428 0 19.9509 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2088_35381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePause);
export default __webpack_public_path__ + "static/media/mobilePause.11277ad3bebfb287236dabf0738a82b1.svg";
export { ForwardRef as ReactComponent };